import { getBlogImageUrlUpdated } from '@components/Blogs/helper';
import { calculateEstimatedReadTime } from '@helpers/estimatedReadTime';
import { formatDate } from '@helpers/miscelleanous';
import { Image, Link, Text } from '@ui/atoms';
import { cn } from '@ui/atoms/utils/utils';
import React from 'react';

const BlogsList = ({ blogList, isCarousel = false }) => {
    const getSpeed = (blog) => calculateEstimatedReadTime(blog?.content);

    const featuredImage = (blog) => {
        if (
            blog?.featuredImage?.node?.mediaItemUrl ||
            blog?.featuredImage?.node?.sourceUrl
        ) {
            return (
                <Image
                    src={getBlogImageUrlUpdated(
                        blog?.featuredImage?.node?.mediaItemUrl ||
                            blog?.featuredImage?.node?.sourceUrl
                    )}
                    alt="featuredImage"
                    className="img-fluid rounded-t-3xl h-[180px]  object-cover mx-auto"
                />
            );
        }
        return null;
    };
    return blogList?.length > 0
        ? blogList.map((blog, index) => (
              <div
                  className={cn(
                      'w-full h-[308px]',
                      isCarousel && 'min-w-[280px] h-full',
                      isCarousel && index === 0 && 'ml-4',
                      !isCarousel &&
                          index === blogList.length - 1 && [
                              'md:col-span-2',
                              'md:col-start-1',
                              'md:mx-auto',
                              'md:max-w-[50%]',
                              'lg:col-span-1',
                              'lg:col-start-auto',
                              'lg:mx-0',
                              'lg:max-w-none',
                          ]
                  )}
                  id={blog?.id}
              >
                  <div className="h-full bg-basicWhite rounded-3xl max-w-[395px] flex flex-col shadow-md">
                      <Link
                          href={`/blogs/${encodeURIComponent(blog?.slug)}`}
                          legacyBehavior
                          target="_blank"
                          className="hidden lg:inline-block"
                      >
                          <figure
                              className={`rounded-t-3xl h-[180px]  cursor-pointer ${
                                  !featuredImage(blog) && 'bg-gray-50'
                              }`}
                          >
                              {featuredImage(blog)}
                          </figure>
                      </Link>
                      <Link
                          href={`/blogs/${encodeURIComponent(blog?.slug)}`}
                          legacyBehavior
                          className="lg:hidden"
                      >
                          <figure
                              className={`rounded-t-3xl h-[180px]  cursor-pointer ${
                                  !featuredImage(blog) && 'bg-gray-50'
                              }`}
                          >
                              {featuredImage(blog)}
                          </figure>
                      </Link>

                      <div className="rounded-b-3xl flex flex-1 flex-col justify-between">
                          <div className="flex flex-col flex-1 ">
                              <ul
                                  className={`flex justify-between items-center text-gray-500  p5-medium 
                        bg-homepage-blog-item-bg px-3 py-2 `}
                              >
                                  <li className={'truncate w-40'}>
                                      {blog?.categories?.edges
                                          .map((edge) => edge.node.name)
                                          .join(',')}
                                  </li>
                                  <li className="text-end w-fit truncate">
                                      {blog?.content &&
                                          `${getSpeed(blog)} min read`}
                                  </li>
                              </ul>
                              <div className="flex flex-col flex-1 justify-between gap-2 px-4 py-3">
                                  <h2
                                      className={`h6-semibold text-gray-900 
            line-clamp-2`}
                                  >
                                      {blog?.slug ? (
                                          <>
                                              <Link
                                                  href={`/blogs/${blog.slug}`}
                                                  className={
                                                      'h6-semibold line-clamp-2 hidden lg:inline'
                                                  }
                                                  target={'_blank'}
                                              >
                                                  {blog?.title}
                                              </Link>
                                              <Link
                                                  href={`/blogs/${blog.slug}`}
                                                  className={
                                                      'h6-semibold line-clamp-2 lg:hidden'
                                                  }
                                              >
                                                  {blog?.title}
                                              </Link>
                                          </>
                                      ) : (
                                          blog?.title
                                      )}
                                  </h2>
                                  <footer className={`flex gap-2 items-center`}>
                                      {blog?.date ? (
                                          <>
                                              <Text
                                                  content={
                                                      blog?.author?.node
                                                          ?.firstName
                                                  }
                                                  className="p5-semibold text-primary-500"
                                              />
                                              <Image
                                                  src="/images/grayEllipse.svg"
                                                  className="w-1 h-1"
                                              />
                                              <Text
                                                  content={formatDate(
                                                      blog?.date
                                                  )}
                                                  className="p5-medium text-primary-500"
                                              />
                                          </>
                                      ) : (
                                          <span className="w-1/2"></span>
                                      )}
                                  </footer>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          ))
        : null;
};
export default BlogsList;
